import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import ServiceDetail from "./pages/ServiceDetail";
import Technology from "./pages/Technology";
import TechnologyDetail from "./pages/TechnologyDetail";
import Industries from "./pages/Industries";
import IndustryDetail from "./pages/IndustryDetail";
import WhyChooseUsDetail from "./pages/WhyChooseUsDetail";
import CaseStudies from "./pages/CaseStudies";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
import Contact from "./pages/Contact";
import AdminBlog from "./pages/AdminBlog";
import AdminLogin from "./pages/AdminLogin";
import AdminUsers from "./pages/AdminUsers";
import Signup from "./pages/Signup";
import Account from "./pages/Account";
import Notes from "./pages/Notes";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import initTouchMotion from "./lib/touchMotion";

function App() {
   useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  // Gives the :hover card flourishes a scroll-based trigger on phones, where
  // a finger can't produce a hover. No-ops on pointer devices.
  useEffect(() => initTouchMotion(), []);
  return (
    <BrowserRouter>
      <AuthProvider>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:slug" element={<ServiceDetail />} />
        <Route path="/technology" element={<Technology />} />
        <Route path="/technology/:slug" element={<TechnologyDetail />} />
        <Route path="/industries" element={<Industries />} />
        <Route path="/industries/:slug" element={<IndustryDetail />} />
        <Route path="/why-choose-us/:slug" element={<WhyChooseUsDetail />} />
        <Route path="/case-studies" element={<CaseStudies />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:id" element={<BlogDetail />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/notes" element={<Notes />} />

        {/* Auth */}
        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<AdminLogin />} />
        {/* Backwards-compatible redirect for the old login URL */}
        <Route
          path="/admin/login"
          element={<Navigate to="/login" replace />}
        />
        <Route
          path="/account"
          element={
            <ProtectedRoute>
              <Account />
            </ProtectedRoute>
          }
        />

        {/* Admin-only */}
        <Route
          path="/admin/blog"
          element={
            <ProtectedRoute adminOnly>
              <AdminBlog />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/users"
          element={
            <ProtectedRoute adminOnly>
              <AdminUsers />
            </ProtectedRoute>
          }
        />
      </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;